import { render } from "./LifetimeStatsChart.vue?vue&type=template&id=7481b6fa"
import script from "./LifetimeStatsChart.vue?vue&type=script&lang=js"
export * from "./LifetimeStatsChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__